<template>

<div id="slide02" class="section section-white">

  <div id="slide02-text" class="two-thirds-block two-thirds-block-1">

    <Subtitle :text="$t('home.slide02.title')"/>

    <div class="ul-div">

      <Ul
        section="slide02"
        :items="[
          $t('home.slide02.bullets.bullet01'),
          $t('home.slide02.bullets.bullet02'),
          $t('home.slide02.bullets.bullet03')
        ]"/>

    </div>

  </div>

  <div id="slide02-image" class="one-third-block one-third-block-2">
    <Qimage name="technology.png"/>
  </div>

</div>

</template>

<script>
import Subtitle from '../general/texts/Subtitle.vue'
import Ul from '../general/elements/Ul.vue'
import Qimage from '../general/elements/Qimage.vue'

export default {
  name: 'Slide02',
  components: {
    Subtitle,
    Ul,
    Qimage
  }
}
</script>

<style lang="scss" scoped>
.section {
  width: 100%;
  padding: 0;
  position: relative;

  .two-thirds-block-1 {
    width: 50%;
    padding: 100px 0 100px 15%;
    margin: 10px 0;

    .ul-div {
      font-size: 24px;
    }
  }

  .one-third-block-2 {
    position: absolute;
    right: 0;
    bottom: 0;

    img {
      width: 55%;
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }
}

@media (max-width: 2500px), (max-device-width: 2500px) {
  .section {
    .one-third-block-2 {
      img {
        width: 100%;
      }
    }
  }
}

@media (max-width: 900px), (max-device-width: 900px) {
  .section {
    width: 80%;
    padding: 100px 10%;

    .two-thirds-block-1 {
      width: 100%;
      padding: 0;
      margin: 0;
      position: relative;
      top: 0;
      left: 0;
      z-index: 1;
      text-shadow: 1px 1px rgba(255, 255, 255, 0.5);
    }

    .one-third-block-2 {
      width: 100%;
      margin: 0;
      opacity: 0.3;

      img {
        width: 60%;
      }
    }
  }
}

@media (max-width: 750px), (max-device-width: 750px) {
  .section {
    .one-third-block-2 {
      img {
        width: 50%;
      }
    }
  }
}

@media (max-width: 600px), (max-device-width: 600px) {
  .section {
    .one-third-block-2 {
      img {
        width: 75%;
      }
    }
  }
}

@media (max-width: 450px), (max-device-width: 450px) {
  .section {
    .one-third-block-2 {
      img {
        width: 100%;
      }
    }
  }
}
</style>
